/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderrefunded2Inputs */

const en_ticketsorderrefunded2 = /** @type {(inputs: Ticketsorderrefunded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

const de_ticketsorderrefunded2 = /** @type {(inputs: Ticketsorderrefunded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstattet`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Ticketsorderrefunded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderrefunded2 = /** @type {((inputs?: Ticketsorderrefunded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderrefunded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderrefunded2(inputs)
	return de_ticketsorderrefunded2(inputs)
});
export { ticketsorderrefunded2 as "ticketsOrderRefunded" }